module.exports = __webpack_public_path__ + "static/media/karacter-bg.5e30d013.png";